import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface LsAccountingLink {
  url: string | SafeResourceUrl;
  accountExists: boolean;
}

interface LsAccountingResponse {
  data: LsAccountingLink;
}

@Injectable({ providedIn: 'root' })
export class LsAccountingService {
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  public getMagicLink(): Observable<LsAccountingLink> {
    return this.http
      .get<LsAccountingResponse>(
        '/PosServer/rest/manager/v1/accounting/web-link'
      )
      .pipe(
        map(response => response.data),
        map(data => {
          if (data.accountExists) {
            data.url = this.sanitizer.bypassSecurityTrustResourceUrl(
              data.url as string
            );
          }
          return data;
        })
      );
  }
}
